import { render, staticRenderFns } from "./vip-authorize-modal.vue?vue&type=template&id=48f6891c&scoped=true"
import script from "./vip-authorize-modal.vue?vue&type=script&lang=js"
export * from "./vip-authorize-modal.vue?vue&type=script&lang=js"
import style0 from "./vip-authorize-modal.vue?vue&type=style&index=0&id=48f6891c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48f6891c",
  null
  
)

export default component.exports